import React, { useState } from "react";
import { CheckCircle, User, MapPin, Phone, AlertTriangle, Calendar, Home } from "lucide-react";
import "../Styles/OnboardScreen.css";
import { apiGet, apiPatch, apiPost } from "../Api/Client.js";
import { resolveActiveEmployee } from "../Shared/ScreenUtils.jsx";

export default function OnboardingScreen({ data, reload, navigate }) {
  const employee = resolveActiveEmployee(data);
  const [form, setForm] = useState({
    display_name: employee?.display_name || "",
    contact_number: employee?.contact_number || "",
    city: employee?.city || "",
    emergency_contact: employee?.profile_payload?.emergency_contact || "",
    year_of_graduation: employee?.year_of_graduation || "",
    address: employee?.profile_payload?.address || "",
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const update = (key, value) => setForm((current) => ({ ...current, [key]: value }));

  const submit = async () => {
    if (!form.display_name) {
      setError("Please Provide Your Full Name.");
      return;
    }
    if (!employee?.id) {
      setError("Employee Not Found. Please Refresh The Page.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const payload = {
        display_name: form.display_name,
        contact_number: form.contact_number,
        city: form.city,
        year_of_graduation: Number(form.year_of_graduation) || null,
        profile_payload: {
          ...(employee?.profile_payload || {}),
          emergency_contact: form.emergency_contact,
          address: form.address,
        },
      };
      await apiPatch(`/Users/EmployeeProfiles/${employee.id}/`, payload);
      await apiPost(`/Users/EmployeeProfiles/${employee.id}/complete-onboarding/`, {});
      reload(["me", "employees"]);
      navigate("/home/");
    } catch (err) {
      setError(err?.message || "Failed To Complete Onboarding.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="Onboarding-Screen Screen-Stack">
      <section className="Page-Heading">
        <div>
          <span>Welcome</span>
          <h1>Complete Your Onboarding</h1>
        </div>
      </section>

      <div className="Onboarding-Form-Container">
        <div className="Onboarding-Card">
          <div className="Onboarding-Header">
            <User size={32} />
            <h2>Personal Information</h2>
            <p>Please Provide Your Details To Complete The Setup.</p>
          </div>

          {error && <div className="Login-Error"><AlertTriangle size={16} /> {error}</div>}

          <div className="Form-Grid Two">
            <label>
              Full Name
              <input
                value={form.display_name}
                onChange={(e) => update("display_name", e.target.value)}
              placeholder="Your Full Legal Name"
            />
          </label>
          <label>
            Phone Number
            <input
              type="tel"
              value={form.contact_number}
              onChange={(e) => update("contact_number", e.target.value)}
              placeholder="+91 XXXXXXXXXX"
            />
          </label>
          <label>
            City
            <input
              value={form.city}
              onChange={(e) => update("city", e.target.value)}
              placeholder="Your Current City"
            />
          </label>
          <label>
            Emergency Contact
            <input
              value={form.emergency_contact}
              onChange={(e) => update("emergency_contact", e.target.value)}
              placeholder="Name - Relationship - Phone"
            />
          </label>
          <label>
            Year Of Graduation
            <input
              type="number" min="2000" max="2030"
              value={form.year_of_graduation}
              onChange={(e) => update("year_of_graduation", e.target.value)}
              placeholder="e.g. 2026"
            />
          </label>
          <label style={{ gridColumn: "1/-1" }}>
            Address
            <textarea
              rows={2}
              value={form.address}
              onChange={(e) => update("address", e.target.value)}
              placeholder="Your Full Address"
              style={{ resize: "vertical" }}
            />
          </label>
        </div>

        <button className="Primary-Button" onClick={submit} disabled={busy}>
          {busy ? "Completing..." : "Complete Onboarding"} <CheckCircle size={16} />
        </button>
        </div>
      </div>
    </section>
  );
}